import React, {useState} from 'react';
import Customer from '../../../types/Customer';
import AdminRadiobox from '../../admin-radiobox';
import Button from '../../button';
import {getAttributeValue} from "../../../lib/attribute";
import useUpdateCustomerState from "../../../hooks/use-update-customer-state";

interface Props {
  customer: Customer;
}

const AdminUserIsEmailVerifiedForm: React.FC<Props> = ({ customer }) => {
  const [isEmailVerified, setIsEmailVerified] = useState(
    getAttributeValue(customer.attributes, 'isEmailVerified')
  );

  const [message, setMessage] = useState('');
  const updateIsEmailVerifiedState = useUpdateCustomerState(() => {
    setMessage('Successfully updated is email verified details.');
  });

  const onClick = () => {
    setMessage('');

    updateIsEmailVerifiedState(
      process.env.SITE as string,
      customer.id,
      'isEmailVerified',
      isEmailVerified === "true"
    );
  };

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
    }}>
      <h2>Is Email Verified?</h2>
      <div className="is-email-verified">
        {[
          {
            id: 'true',
            label: 'Yes',
          },
          {
            id: 'false',
            label: 'No',
          },
          // @ts-ignore
        ].map((s) => (
          <AdminRadiobox
            key={s.id}
            name="status"
            id={s.id}
            label={s.label}
            checked={s.id.toLowerCase() === isEmailVerified.toLowerCase()}
            onChange={() => setIsEmailVerified(s.id)}
          />
        ))}
      </div>
      {message && <p>{message}</p>}
      <Button text="Save" onClick={onClick}/>
      {/* language=CSS */}
      <style jsx>{`
        .is-email-verified {
          display: flex;
          flex-wrap: wrap;
        }

        .is-email-verified > :global(.radiobox-group) {
          flex-grow: 0;
          width: 33%;
          margin-bottom: 1rem;
        }
      `}</style>
    </form>
  );
};

export default AdminUserIsEmailVerifiedForm;
